<!-- 選擇產品群組項目 -->
<ng-template #Modal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
    <nb-card-header>
      {{ t('common_choose_product_kind', '選擇商品種類') }}
    </nb-card-header>
    <nb-card-body class="staffInfoTemplate">
      <div class="row mx-0 mt-3">
        <input
          class="col"
          [(ngModel)]="query.searchKey"
          name="searchKey"
          type="text"
          nbInput
          fullWidth
          shape="rectangle"
          [placeholder]="t('common_search_product_name', '查詢商品名')">
        <button class="col-auto ml-2 btn" nbButton (click)="onQuery()">
          <i class="fas fa-search"></i>
        </button>
      </div>

      <div class="d-flex mx-0 mt-2 justify-content-between">
        <nb-select class="col-auto pr-0 ml-auto" style="width:180px" [(ngModel)]="selectORG_Store_ID" (selectedChange)="onQuery()">
          <nb-option *ngFor="let e of storeSelectList" [value]="e.value">{{ e.content }}</nb-option>
        </nb-select>
      </div>

      <div class="mt-3">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ t('common_product_name', '商品名稱') }}</th>
              <th>{{ t('common_create_store', '建立門市') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="mainDataList && mainDataList.length">
              <td><b class="text-info">{{ t('common_select_all', '全選') }}</b></td>
              <td></td>
              <td>
                <b class="text-info">{{ t('common_select', '選擇') }}{{ status.AllSelectCount }}{{ t('common_quantity', '數量') }}</b>
              </td>
            </tr>
            <ng-container *ngFor="let e of mainDataList ">
              <tr>
                <td>{{ e.GroupName }}</td>
                <td style="vertical-align: middle;">{{ e.CreateStoreName }}</td>
                <td>
                  <button nbButton class="m-0 col-sm-12" (click)="onOpenPd(e.GroupNo)">
                    {{ e.CountStr ? e.CountStr : t('common_select', '選擇') }}
                  </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="onSavePdG();">{{ t('common_confirm', '確定') }}</button>
      <button nbButton (click)="ref.close()">{{ t('common_close', '關閉') }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

  
  <!-- 選擇產品 -->
<ng-template #PdModal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate">
    <nb-card-header>
      {{ t('common_choose_product', '選擇商品') }}
    </nb-card-header>
    <nb-card-body class="staffInfoTemplate">
      <div class="mt-3">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ t('common_create_store', '建立門市') }}</th>
              <th>{{ t('common_product_name', '商品名稱') }}</th>
              <th>{{ t('common_original_price', '原價') }}</th>
              <th>{{ t('common_enable', '啟用') }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let e of showListPd">
              <tr>
                <td style="vertical-align: middle;">{{ e.CreateStoreName }}</td>
                <td>{{ e.Name }}</td>
                <td>{{ e.Cash }}</td>
                <td>
                  <nb-toggle
                    status="info"
                    [(checked)]="e.IsOK_Product"
                    (change)="checkModuleValue(e)">
                  </nb-toggle>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="onSavePd();">{{ t('common_confirm', '確定') }}</button>
      <button nbButton (click)="ref.close()">{{ t('common_cancel', '取消') }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
